<template>
  <div>
    <v-card class="px-6 py-3 mt-3 mb-6" v-if="company.isUserValidationNecessary">
      <v-layout wrap>
        <v-flex>
          <b>{{ company.name }}</b>
          <div v-if="userValidationWithInvitation">
            <small>{{ $t('a') }}</small>
          </div>
        </v-flex>
        <v-flex class="text-end" pt-2>
          <v-btn v-if="userValidationWithInvitation" small class="secondary" @click="acceptInvitationToJoinTeam">
            {{ $t('b') }}
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout wrap v-if="!userValidationWithInvitation">
        <v-flex xs12>
          <small>
            <v-layout wrap>
              <v-flex xs12>
                <b>{{ $t('c') }}</b>
              </v-flex>
            </v-layout>
            <!-- List company managers and admins -->
            <v-layout wrap>
              <v-flex xs12 v-for="(manager, index) in company.managers" :key="index">
                <v-divider v-if="index > 0"></v-divider>
                <v-layout wrap class="my-4">
                  <v-flex xs6 pt-1>
                    <span>{{ [manager.firstName, manager.lastName].filter(Boolean).join(' ') }}</span>
                  </v-flex>
                  <v-flex xs6 text-end>
                    <div v-if="hasARequestEmailHasBeenSendToThisManager(manager)" class="pt-1">
                      <div>
                        <v-icon class="secondary--text mr-2" small>mdi-check</v-icon>
                        <span class="secondary--text">{{ $t('d') }}</span>
                      </div>
                      <div>
                        <span class="orange--text">{{ $t('e') }}</span>
                      </div>
                    </div>
                    <div v-else>
                      <v-btn small @click="showSendARequestEmail(manager)" class="secondary">
                        <v-icon class="mr-2">mdi-email-fast</v-icon>
                        {{ $t('f') }}
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </small>
        </v-flex>
      </v-layout>
    </v-card>

    <v-card class="px-6 py-6 mt-3 mb-6" v-else>
      <v-layout wrap>
        <v-flex xs6 pt-1>
          <b>{{ company.name }}</b>
        </v-flex>
        <v-flex xs6 text-end>
          <v-btn small class="secondary" @click="joinCompanyWithoutValidation">{{ $t('m') }}</v-btn>
        </v-flex>
      </v-layout>
    </v-card>

    <v-dialog v-model="isShowingSendARequestEmail" width="40%" :persistent="isSendingRequestEmail" v-if="shownManagerToSendARequestTo">
      <v-card class="px-6 pb-6 pt-3">
        <v-layout wrap v-if="!isSendingRequestEmail">
          <v-flex xs12>
            <v-layout wrap>
              <v-flex xs12 text-center>
                <h3>{{ $t('g') }}</h3>
              </v-flex>
              <v-flex xs12 my-3>
                <small>
                  <div>{{ $t('h') }} {{ [shownManagerToSendARequestTo.firstName, shownManagerToSendARequestTo.lastName].filter(Boolean).join(' ') }}.</div>
                  <div>{{ $t('i') }}</div>
                </small>
              </v-flex>
            </v-layout>
            <v-layout wrap mt-3>
              <v-flex xs6 text-center>
                <v-btn class="primary" @click="sendRequestEmailToManager">{{ $t('j') }}</v-btn>
              </v-flex>
              <v-flex xs6 text-center>
                <v-btn outlined @click="isShowingSendARequestEmail = false">{{ $t('k') }}</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout wrap v-if="isSendingRequestEmail">
          <v-flex xs12 text-center>
            <div class="mb-2"><b>{{ $t('l') }}</b></div>
            <v-progress-linear indeterminate color="primary"></v-progress-linear> 
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  props: {
    company: Object
  },
  data: () => ({
    isShowingSendARequestEmail: false,
    shownManagerToSendARequestTo: null,
    isSendingRequestEmail: false
  }),
  computed: {
    userValidationWithInvitation() {
      return this.company.userValidations.find(userValidation => userValidation.type === 'invitation')
    },
    userValidationWithRequest() {
      return this.company.userValidations.find(userValidation => userValidation.type === 'request')
    },
  },
  methods: {
    hasARequestEmailHasBeenSendToThisManager(manager) {
      return this.company.userValidations.find(userValidation => userValidation.requestSentToManagerIds.includes(manager.id))
    },
    showSendARequestEmail(manager) {
      this.shownManagerToSendARequestTo = manager
      this.isShowingSendARequestEmail = true
    },
    async sendRequestEmailToManager() {
      this.isSendingRequestEmail = true
      // Send email
      await this.$functions.httpsCallable('sendRequestEmailToManager')({ managerId: this.shownManagerToSendARequestTo.id })

      // Refresh companies
      this.$emit('refreshCompanies')

      this.shownManagerToSendARequestTo = null
      this.isShowingSendARequestEmail = false
      this.isSendingRequestEmail = false
    },
    async acceptInvitationToJoinTeam() {
      this.$emit('setIsJoiningCompany', true)
      await this.$functions.httpsCallable('acceptInvitationToJoinCompany')({ companyId: this.company.id })
    },
    async joinCompanyWithoutValidation() {
      this.$emit('setIsJoiningCompany', true)
      await this.$functions.httpsCallable('joinCompanyWithoutValidation')({ companyId: this.company.id })
      // User will automatically be redirected to /dossiers thanks to watch of user.companyId in parent View. 
    }
  }
  
}
</script>


<i18n>
{
  "fr": {
    "a": "Vous avez été invité à rejoindre cette équipe.",
    "b": "Rejoindre",
    "c": "Demandez à un manager de vous accepter dans l'équipe :",
    "d": "Demande envoyée.",
    "e": "En attente de validation.",
    "f": "Demander une invitation",
    "g": "Demande d'invitation",
    "h": "Un email sera envoyé à",
    "i": "Lorsque que votre demande sera validée, vous pourrez rejoindre l'équipe.",
    "j": "Envoyer",
    "k": "Annuler",
    "l": "Envoi de l'email en cours",
    "m": "Rejoindre l'équipe"
  },
  "en": {
    "a": "You have been invited to join this team.",
    "b": "Join",
    "c": "Ask a manager to join this team:",
    "d": "Request sent.",
    "e": "Waiting for approval.",
    "f": "Request to join",
    "g": "Request to join the team",
    "h": "An email will be sent to",
    "i": "When your request is approved, you will be able to join the team.",
    "j": "Send",
    "k": "Cancel",
    "l": "Request is being sent",
    "m": "Join team"
  }
}
</i18n>